angular
  .module('app')
  .factory('GTMManager', GTMManager);


function GTMManager(Currency) {
  var $this = this;
  $this.Currency = Currency;

  function setSearchItemsEvent(searchParams) {

    var params = {
      event: 'search_items',
      arrival_date: searchParams.start,
      departure_date: searchParams.end,
      persons_count: searchParams.persons_count,
      language: searchParams.language,
      discount_code_name: searchParams.discount_code_name,
      featured_room_type_id: searchParams.featured_group_id,
      featured_rate_plan_id: searchParams.featured_rate_id
    };

    JSON.parse(searchParams.age_counts[0]).forEach(function (ageCount) {
      var yourKeyVariable = 'age_category_' + ageCount.age_category_id;
      params[yourKeyVariable] = ageCount.count || 0;
    });

    dataLayer.push(params);
  }

  function setViewItemEvent(filteredOffersList) {

    filteredOffersList.forEach(function (offer) {
      offer.rateplans.forEach(function (rateplan) {

        var params = {
          event: 'view_item',
          ecommerce: {
            currency: Currency.getCurrency(),
            value: rateplan.prices.discountPrice,
            items: [{
              item_id: '' + offer.room.id + '-' + rateplan.id + '',
              item_name: '' + offer.room.name + '-' + rateplan.name + '',
              price: rateplan.prices.discountPrice,
              quantity: 1
            }]
          }
        };

        // dataLayer.push({ ecommerce: null });
        dataLayer.push(params);
      })
    });
  }

  function setSelectItemEvent(room, rateplan) {
    var items = [{
        item_id: '' + room.id + '-' + rateplan.id + '',
        item_name: '' + room.name + '-' + rateplan.name + '',
        price: rateplan.prices.discountPrice,
        quantity: 1
    }];

    var params = {
      event: 'select_item',
      ecommerce: {
        items: items
      }
    };

    // dataLayer.push({ ecommerce: null });
    dataLayer.push(params);
  }

  function setAddToCartEvent(room, rateplan) {

    var params = {
      event: 'add_to_cart',
      ecommerce: {
        currency: Currency.getCurrency(),
        value: rateplan.prices.discountPrice,
        items: [{
          item_id: '' + room.id + '-' + rateplan.id + '',
          item_name: '' + room.name + '-' + rateplan.name + '',
          price: rateplan.prices.discountPrice,
          quantity: 1
        }]
      }
    };

    // dataLayer.push({ ecommerce: null });
    dataLayer.push(params);
  }

  function setBeginCheckoutEvent(filteredOffersList) {

    var items = [];
    var value = 0;

    filteredOffersList.forEach(function (offer) {
      offer.rateplans.forEach(function (rateplan) {

        value = value + rateplan.prices[0].discountPrice;
        items.push({
          item_id: '' + offer.room.id + '-' + rateplan.id + '',
          item_name: '' + offer.room.name + '-' + rateplan.name + '',
          price: rateplan.prices[0].discountPrice,
          quantity: 1
        });

      })
    });

    var params = {
      event: 'begin_checkout',
      ecommerce: {
        currency: Currency.getCurrency(),
        value: value,
        items: items
      }
    };

    // dataLayer.push({ ecommerce: null });
    dataLayer.push(params);
  }

  function setPurchaseEvent(reservationId, offers) {

    var items = [];
    var value = 0;

    offers.forEach(function (offer) {
      offer.rateplans.forEach(function (rateplan) {

        value = value + rateplan.prices[0].discountPrice;
        items.push({
          item_id: '' + offer.room.id + '-' + rateplan.id + '',
          item_name: '' + offer.room.name + '-' + rateplan.name + '',
          price: rateplan.prices[0].discountPrice,
          quantity: 1
        });

      })
    });

    var params = {
      event: 'purchase',
      ecommerce: {
        transaction_id: reservationId,
        currency: Currency.getCurrency(),
        value: value,
        items: items
      }
    };
    // dataLayer.push({ ecommerce: null });
    dataLayer.push(params);
  }



  return {
    setSearchItemsEvent: setSearchItemsEvent,
    setViewItemEvent: setViewItemEvent,
    setSelectItemEvent: setSelectItemEvent,
    setAddToCartEvent: setAddToCartEvent,
    setBeginCheckoutEvent: setBeginCheckoutEvent,
    setPurchaseEvent: setPurchaseEvent
  };
}
